const allowedInlineTags = new Set(['b', 'i', 'u', 's', 'sub', 'sup']);
const supportedInlineTagAliases = new Map([
  ['strong', 'b'],
  ['em', 'i'],
  ['strike', 's'],
]);
const blockTags = new Set([
  'address',
  'article',
  'aside',
  'blockquote',
  'div',
  'footer',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'header',
  'li',
  'main',
  'ol',
  'p',
  'pre',
  'section',
  'ul',
]);

export function sanitizeDevExpressMarkupText(value: string): string {
  if (!value) {
    return '';
  }

  const document = new DOMParser().parseFromString(value, 'text/html');
  return Array.from(document.body.childNodes)
    .map((node) => serializeNode(node))
    .join('')
    .replace(/(?:<br>)+$/g, '')
    .trim();
}

function serializeNode(node: Node): string {
  if (node.nodeType === Node.TEXT_NODE) {
    return escapeText(node.textContent ?? '');
  }

  if (node.nodeType !== Node.ELEMENT_NODE) {
    return '';
  }

  const element = node as HTMLElement;
  const tagName = element.tagName.toLowerCase();

  if (tagName === 'br') {
    return '<br>';
  }

  if (tagName === 'nbsp') {
    return '<nbsp>';
  }

  const content = Array.from(element.childNodes)
    .map((childNode) => serializeNode(childNode))
    .join('');

  const supportedTagName = supportedInlineTagAliases.get(tagName) ?? tagName;

  if (allowedInlineTags.has(supportedTagName)) {
    return `<${supportedTagName}>${content}</${supportedTagName}>`;
  }

  if (blockTags.has(tagName)) {
    return appendLineBreak(content);
  }

  return content;
}

function appendLineBreak(value: string): string {
  if (!value || value.endsWith('<br>')) {
    return value;
  }

  return `${value}<br>`;
}

function escapeText(value: string): string {
  return value
    .replace(/\u00a0/g, ' ')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}
